import AlertStore from './store';

const store = new AlertStore();

const install = Vue => {
  if (Vue.prototype.$alert) {
    console.error('[alert-box-plugin] An other plugin already uses namespace "Vue.$alert".');
    return;
  }

  Object.defineProperty(Vue.prototype, '$alert', {
    value: {
      push(...args) {
        return store.push(...args);
      },
    },
  });
};

export const AlertPortal = {
  name: 'AlertPortal',
  props: {
    listComponent: {
      type: Object, // Vue Component
      required: true,
    },
  },
  computed: {
    items() {
      return store.items;
    },
  },
  render(h) {
    return h(this.listComponent, {
      props: {
        items: this.items,
      },
      on: {
        close(id) {
          store.delete(id);
        },
      },
    });
  },
};

export default {
  install,
};
